import {isWebviewBuild, isWebviewCountriesOf, isWebviewCountryOf} from "./utils/config.utils";

window.clientConfig.features = {};

// Условие для показа тунорг баннера
window.clientConfig.features.showToonorgBanner = window.clientConfig.queryParams.utm_source === "toonorg";

window.clientConfig.features.isAutoStartCreatives = window.clientConfig.splitGroupId < 11; // true
window.clientConfig.features.tabsWithRandomOrder = true;
window.clientConfig.features.showResubscribeView = !window.clientConfig.isPro
  && window.clientConfig.isCancelledTrial
  && [6, 7, 8, 9, 10].includes(window.clientConfig.splitGroupId);

window.clientConfig.features.fullSizeIsAvailable = isWebviewBuild(70, 146);
window.clientConfig.features.showNeuroAvatars = false; //isWebviewBuild(108, 317);

window.clientConfig.features.withCryptoBanner = true;
window.clientConfig.features.cryptoBannerLink = "https://t.me/toon_nation_bot/toon_nation?startapp=6890486956";

const androidPreResultIgnoredCountries = [
  'IR', 'IN', 'RU', 'DZ', 'IQ', 'BD', 'LK', 'NP', 'MM', 'BN', 'BT',
  'AZ', 'KG', 'UZ', 'GE', 'AM', 'TJ', 'TM', 'NG', 'GH', 'RE', 'CI',
  'CM', 'TZ', 'SN', 'ZW', 'AO', 'UG', 'ZM', 'MG', 'NA', 'GA', 'MZ',
  'CD', 'SD', 'ET', 'BW', 'TG', 'BJ', 'GN', 'ML', 'RW', 'BF', 'SO',
  'LR', 'MW', 'CG', 'CV', 'MR', 'DJ', 'NE', 'SL', 'SZ', 'GQ', 'BI',
  'GM', 'LS', 'TD', 'CF', 'SS', 'GW', 'ER',
];

window.clientConfig.features.showFullSizeBannerDisabledByRegion =
  (window.clientConfig.isWebviewIos && isWebviewCountryOf("IR", true))
  || (window.clientConfig.isWebviewAndroid && isWebviewCountriesOf(androidPreResultIgnoredCountries, true))

window.clientConfig.features.showFullSizeBanner = isWebviewBuild(87, 241)
  && !window.clientConfig.isPro
  && !window.clientConfig.isTurkeyUser
;

window.clientConfig.features.showD31Group = true;
